import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  FormGroup,
  Label,
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Col,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import Select from "react-select";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const AddCourseForm = ({ values, errors, touched, isSubmitting }) => {
  const handleChange = (selected) => {
    values.selectedProgramLicenses = selected;
  };

  return (
    <div className="col-12 col-sm-12">
      <Form>
        <FormGroup row>
          <Label lg={3}>Namn</Label>
          <Col lg={9}>
            <Field
              className={`form-control ${
                errors.name && touched.name && "is-invalid"
              }`}
              type="input"
              name="name"
              value={values.name}
            />
            {errors.name && touched.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label lg={3}>Beskrivning</Label>
          <Col lg={9}>
            <Field
              className={`form-control ${
                errors.description && touched.description && "is-invalid"
              }`}
              type="textarea"
              name="description"
            />
            {errors.description && touched.description && (
              <div className="invalid-feedback">{errors.description}</div>
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label lg={3}>Bild i formatet 16:9</Label>
          <Col lg={9}>
            <input
              id="imgFile"
              name="imgFile"
              type="file"
              className={`form-control ${
                errors.imgFile && touched.imgFile && "is-invalid"
              }`}
              onChange={(event) => {
                values.imgFile = event.currentTarget.files[0];
              }}
            />
            {errors.imgFile && touched.imgFile && (
              <div className="invalid-feedback">{errors.imgFile}</div>
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label lg={3}>Fortnox artikelnr</Label>
          <Col lg={9}>
            <Field
              className={`form-control ${
                errors.fortKnoxArticleNumber &&
                touched.fortKnoxArticleNumber &&
                "is-invalid"
              }`}
              type="input"
              name="fortKnoxArticleNumber"
            />
            {errors.fortKnoxArticleNumber && touched.fortKnoxArticleNumber && (
              <div className="invalid-feedback">
                {errors.fortKnoxArticleNumber}
              </div>
            )}
          </Col>
        </FormGroup>
        <Card>
          <CardHeader onClick={values.toggleExpand}>
            Webbad Learnware{" "}
            <span
              className={
                values.isExpanded
                  ? "fa fa-caret-up pull-right"
                  : "fa fa-caret-down pull-right"
              }
            />
          </CardHeader>
          <Collapse isOpen={values.isExpanded}>
            <CardBody>
              <FormGroup row>
                <Label lg={3}>Kod</Label>
                <Col lg={9}>
                  <Field
                    className={`form-control ${
                      errors.code && touched.code && "is-invalid"
                    }`}
                    type="input"
                    name="code"
                  />
                  {errors.code && touched.code && (
                    <div className="invalid-feedback">{errors.code}</div>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label lg={3}>LWGuid</Label>
                <Col lg={9}>
                  <Field
                    className={`form-control ${
                      errors.lwGuid && touched.lwGuid && "is-invalid"
                    }`}
                    type="input"
                    name="lwGuid"
                  />
                  {errors.lwGuid && touched.lwGuid && (
                    <div className="invalid-feedback">{errors.lwGuid}</div>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label lg={3}>LW Start-modul</Label>
                <Col lg={9}>
                  <Field
                    className={`form-control ${
                      errors.lwStartModule &&
                      touched.lwStartModule &&
                      "is-invalid"
                    }`}
                    type="input"
                    name="lwStartModule"
                  />
                  {errors.lwStartModule && touched.lwStartModule && (
                    <div className="invalid-feedback">
                      {errors.lwStartModule}
                    </div>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label lg={3}>LW Start-modul GUID</Label>
                <Col lg={9}>
                  <Field
                    className={`form-control ${
                      errors.lwStartModuleGuid &&
                      touched.lwStartModuleGuid &&
                      "is-invalid"
                    }`}
                    type="input"
                    name="lwStartModuleGuid"
                  />
                  {errors.lwStartModuleGuid && touched.lwStartModuleGuid && (
                    <div className="invalid-feedback">
                      {errors.lwStartModuleGuid}
                    </div>
                  )}
                </Col>
              </FormGroup>
            </CardBody>
          </Collapse>
        </Card>
        <Card>
          <CardHeader>Programlicens</CardHeader>
          <CardBody>
            {values.courseId === 0 ? (
              <p>
                <FormattedMessage id="ProgramLicenseOnlyPossibleToAddInEditMode" />
              </p>
            ) : (
              <FormGroup>
                <Select
                  placeholder="Välj programlicens/er"
                  isMulti
                  noOptionsMessage={() => "Det finns inga programlicensen"}
                  onChange={(selected) => handleChange(selected)}
                  defaultValue={values.selectedProgramLicenses}
                  options={values.programLicenses.map((option) => ({
                    label: option.licenseName,
                    value: option.licenseName,
                    clearableValue: true,
                  }))}
                />
              </FormGroup>
            )}
          </CardBody>
        </Card>

        <Button
          type="submit"
          outline
          color="primary"
          className="float-end"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Vänta..." : "Spara"}
        </Button>
        <Button
          outline
          color="secondary"
          className="float-end me-2"
          onClick={() => values.dismissModal()}
        >
          <FormattedMessage id="Cancel" />
        </Button>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props, name) => {
    return {
      dismissModal: props.dismissModal,
      toggleExpand: props.toggleExpand,
      refreshList: props.refreshList,
      name: props.updateCourse ? props.updateCourse.name : "",
      description: props.updateCourse ? props.updateCourse.description : "",
      fortKnoxArticleNumber: props.updateCourse
        ? props.updateCourse.fortKnoxArticleNumber
        : "",
      imgFile: props.updateCourse ? props.updateCourse.imgUrl : "",
      code: props.updateCourse ? props.updateCourse.code : "",
      lwGuid:
        props.updateCourse && props.updateCourse.lwGuid
          ? props.updateCourse.lwGuid
          : "",
      lwStartModule:
        props.updateCourse && props.updateCourse.lwStartModule
          ? props.updateCourse.lwStartModule
          : "",
      lwStartModuleGuid:
        props.updateCourse && props.updateCourse.lwStartModuleGuid
          ? props.updateCourse.lwStartModuleGuid
          : "",
      isExpanded: props.updateCourse
        ? props.updateCourse.lwGuid != null
          ? true
          : false
        : props.isExpanded,
      courseId: props.updateCourse ? props.updateCourse.id : 0,
      programLicenses: props.availableProgramLicenses,
      selectedProgramLicenses: props.updateCourse
        ? props.updateCourse.programLicenses.map((option) => ({
            label: option,
            value: option,
            clearableValue: true,
          }))
        : [],
      orgProgramLicenses: props.updateCourse
        ? props.updateCourse.programLicenses
        : [],
      handleToggleCourseAsLoading: props.handleToggleCourseAsLoading,
    };
  },

  validationSchema: Yup.object().shape({
    name: Yup.string().required(
      <FormattedMessage id="Views.Admin.Course.NameIsRequired" />
    ),
    fortKnoxArticleNumber: Yup.string().required(
      <FormattedMessage id="Views.Admin.Course.FortnoxArticleNumberIsRequired" />
    ),
  }),

  handleSubmit(values, { props, setSubmitting }) {
    const toFormData = (file, paramName) => {
      if (!file) return null;
      var myData = new FormData();
      myData.append(paramName, file);
      return myData;
    };
    if (values.courseId === 0) {
      axios
        .post(
          `${API_BASE_URL}/course?Name=${
            values.name
          }&Description=${encodeURIComponent(values.description)}&Code=${
            values.code === "null" || values.code === null ? "" : values.code
          }&fortKnoxArticleNumber=${values.fortKnoxArticleNumber}&lwGuid=${
            values.lwGuid
          }&lwStartModule=${values.lwStartModule}&lwStartModuleGuid=${
            values.lwStartModuleGuid
          }`,
          toFormData(values.imgFile, "ImageFile"),
          { headers: { "Content-Type": "multipart/form-data;" } }
        )
        .then((response) => {
          toast.success("Kursen har lagts till", TOAST_CONFIG);
          values.refreshList();
          values.dismissModal();
        })
        .catch((err) => {
          toast.warn(err.response.data, TOAST_CONFIG);
        });
    } else {
      axios
        .put(
          `${API_BASE_URL}/course?id=${values.courseId}&Name=${
            values.name
          }&Description=${encodeURIComponent(values.description)}&Code=${
            values.code === "null" || values.code === null ? "" : values.code
          }&fortKnoxArticleNumber=${values.fortKnoxArticleNumber}&lwGuid=${
            values.lwGuid
          }&lwStartModule=${values.lwStartModule}&lwStartModuleGuid=${
            values.lwStartModuleGuid
          }`,
          toFormData(values.imgFile, "ImageFile"),
          { headers: { "Content-Type": "multipart/form-data;" } }
        )
        .then((response) => {
          toast.success("Kursen är uppdaterad", TOAST_CONFIG);
          let toggledLoading = false;
          if (values.selectedProgramLicenses.length > 0) {
            values.selectedProgramLicenses.forEach((item) => {
              //Check that it was not already connected
              if (!values.orgProgramLicenses.includes(item.value)) {
                if (!toggledLoading) {
                  values.handleToggleCourseAsLoading(values.courseId);
                  toggledLoading = true;
                }
                axios
                  .post(
                    `${API_BASE_URL}/ProgramLicense/AddCoursesToProgramLicense?licenseName=${item.value}&courseIds=${values.courseId}`
                  )
                  .then(() => {
                    toast.success(
                      "Kursen har lagts till i programlicensen " + item.value
                    );
                    if (toggledLoading) {
                      values.handleToggleCourseAsLoading(values.courseId);
                      toggledLoading = false;
                    }
                  })
                  .catch((err) => {
                    if (toggledLoading) {
                      values.handleToggleCourseAsLoading(values.courseId);
                      toggledLoading = false;
                    }
                    toast.warn(
                      err && err.response && err.response.data
                        ? err.response.data
                        : "Det gick inte att lägga till kursen i programlicensen " +
                            item.value
                    );
                  });
              }
            });
          }
          values.orgProgramLicenses.forEach((currentCourseLicense) => {
            if (
              !values.selectedProgramLicenses.some(
                (item) => item.value === currentCourseLicense
              )
            ) {
              if (!toggledLoading) {
                toggledLoading = true;
                values.handleToggleCourseAsLoading(values.courseId);
              }
              axios
                .delete(
                  `${API_BASE_URL}/ProgramLicense/RemoveCoursesFromProgramLicense?licenseName=${currentCourseLicense}&courseId=${values.courseId}`
                )
                .then(() => {
                  toast.success(
                    "Kursen har plockats bort ifrån programlicensen"
                  );
                  if (toggledLoading) {
                    values.handleToggleCourseAsLoading(values.courseId);
                    toggledLoading = false;
                  }
                })
                .catch((err) => {
                  if (toggledLoading) {
                    values.handleToggleCourseAsLoading(values.courseId);
                    toggledLoading = false;
                  }
                  toast.warn(
                    err && err.response && err.response.data
                      ? err.response.data
                      : "Det gick inte att koppla ifrån kursen ifrån programlicensen"
                  );
                });
            }
          });
          values.dismissModal();
          values.refreshList();
        })
        .catch((err) => {
          toast.warn(err.response?.data, TOAST_CONFIG);
        });
    }
    setSubmitting(false);
  },
})(AddCourseForm);

export default FormikForm;
